module.exports = __webpack_public_path__ + "static/media/js.7c559e5d.png";